import { EditableField } from '@nemuru-eng/js-api-client';
import { useMemo } from 'react';

import { useAutoLoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useAutoLoanPaymentMethodDetailEntity';
import { isEditFinancingEnabled } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/maps/financingEditableFields.map';
import {
  createIsFieldDisabled,
  doesEditableFieldExistInArray,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/maps/editableFieldToFormField.map';
import { getAutoLoanPaymentMethodOptions } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/maps/vehicleModificationPreview.map';

const EMPTY_EDITABLE_FIELDS: EditableField[] = [];

export const useEditAutoPaymentMethodCapabilities = () => {
  const autoLoanEntity = useAutoLoanPaymentMethodDetailEntity();
  const editableFields = autoLoanEntity?.modificationCapability?.editableFields ?? EMPTY_EDITABLE_FIELDS;
  const isSimulatorEnabled = isEditFinancingEnabled(editableFields);
  const showVehicleAmountControl = doesEditableFieldExistInArray(editableFields, EditableField.VEHICLE_AMOUNT);
  const currentPaymentMethodOptions = autoLoanEntity
    ? getAutoLoanPaymentMethodOptions(autoLoanEntity.checkoutSession.paymentMethods)
    : undefined;
  const paymentMethodId = autoLoanEntity?.paymentMethodId;
  const fallbackApr = autoLoanEntity?.loan?.loanConditions.loanCalculator.tae;
  const lenderName = autoLoanEntity?.selectedProvider;
  const lenderRequestId = autoLoanEntity?.lenderRequestId;
  const isFieldDisabled = useMemo(() => createIsFieldDisabled(editableFields), [editableFields]);

  return {
    editableFields,
    isSimulatorEnabled,
    showVehicleAmountControl,
    currentPaymentMethodOptions,
    paymentMethodId,
    fallbackApr,
    lenderName,
    lenderRequestId,
    isFieldDisabled,
  };
};
